import React from 'react';
import { motion } from 'framer-motion';
import { WordPullUp } from './ui/word-pull-up';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen bg-[#2C2721] text-white overflow-x-hidden" style={{
      backgroundImage: 'url(/photo/temp_back.webp)',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }}>
      {/* Hero Content */}
      <div className="container mx-auto px-4 sm:px-6 pt-20 sm:pt-24">
        <div className="flex flex-col items-center justify-center min-h-[calc(100vh-5rem)] text-center pt-48 sm:pt-52 md:pt-64 lg:pt-72 xl:pt-80 2xl:pt-96">
          {/* Centered Content */}
          <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 overflow-hidden" style={{fontFamily: 'Vixa-Regular, sans-serif'}}>
            <WordPullUp
              words="Hi ,  I  am  Krys"
              className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl 2xl:text-[10rem] font-bold mb-2 sm:mb-3 text-[#F1EFE0] leading-tight"
              style={{fontFamily: 'Vixa-Regular, sans-serif'}}
              wrapperFramerProps={{
                hidden: { opacity: 0 },
                show: {
                  opacity: 1,
                  transition: {
                    staggerChildren: 0.3,
                    delay: 0.4,
                  },
                },
              }}
              framerProps={{
                hidden: { y: 40, opacity: 0 },
                show: { 
                  y: 0, 
                  opacity: 1, 
                  transition: { 
                    duration: 1.0,
                    ease: [0.25, 0.46, 0.45, 0.94],
                    type: "spring",
                    damping: 20,
                    stiffness: 100
                  } 
                },
              }}
            />
            <WordPullUp
              words="I'm  a  Software  Engineer"
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl 2xl:text-7xl mb-8 sm:mb-10 text-[#F1EFE0] leading-tight"
              style={{fontFamily: 'Vixa-Regular, sans-serif'}}
              wrapperFramerProps={{
                hidden: { opacity: 0 },
                show: {
                  opacity: 1,
                  transition: {
                    staggerChildren: 0.25,
                    delay: 2.0,
                  },
                },
              }}
              framerProps={{
                hidden: { y: 35, opacity: 0 },
                show: { 
                  y: 0, 
                  opacity: 1, 
                  transition: { 
                    duration: 1.0,
                    ease: [0.25, 0.46, 0.45, 0.94],
                    type: "spring",
                    damping: 20,
                    stiffness: 100
                  } 
                },
              }}
            />

            {/* Social Links */}
            <motion.div 
              className="flex justify-center space-x-4 sm:space-x-6 mb-4 sm:mb-5"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 3.5 }}
            >
              <a href="https://www.linkedin.com/in/ziqi-gao-8b76522b2" target="_blank" rel="noopener noreferrer" className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full border-2 border-[#F1EFE0] text-[#F1EFE0] hover:bg-[#F1EFE0] hover:text-[#2C2721] flex items-center justify-center hover:scale-110 hover:rotate-[360deg] transition-all duration-300">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="https://github.com/KrysG-2004" target="_blank" rel="noopener noreferrer" className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full border-2 border-[#F1EFE0] text-[#F1EFE0] hover:bg-[#F1EFE0] hover:text-[#2C2721] flex items-center justify-center hover:scale-110 hover:rotate-[360deg] transition-all duration-300">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
              <a href="https://www.xiaohongshu.com/user/profile/62edda48000000001e01cf44" target="_blank" rel="noopener noreferrer" className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full border-2 border-[#F1EFE0] text-[#F1EFE0] hover:bg-[#F1EFE0] hover:text-[#2C2721] flex items-center justify-center hover:scale-110 hover:rotate-[360deg] transition-all duration-300">
                <span className="text-xs sm:text-sm md:text-base font-medium">Red</span>
              </a>
              <a href="https://www.instagram.com/krysgao0209/?igsh=MTFqanU0NTFidm1pYw%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full border-2 border-[#F1EFE0] text-[#F1EFE0] hover:bg-[#F1EFE0] hover:text-[#2C2721] flex items-center justify-center hover:scale-110 hover:rotate-[360deg] transition-all duration-300">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zM5.838 12a6.162 6.162 0 1112.324 0 6.162 6.162 0 01-12.324 0zM12 16a4 4 0 110-8 4 4 0 010 8zm4.965-10.405a1.44 1.44 0 112.881.001 1.44 1.44 0 01-2.881-.001z"/>
                </svg>
              </a>
            </motion.div>

            {/* Hire Me Button */}
            <motion.a 
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 4.0 }}
              href="mailto:krysyyds@gmail.com?subject=Hiring%20Inquiry&body=Hi%20Krys,%0A%0AI'm%20interested%20in%20discussing%20a%20potential%20opportunity%20with%20you.%0A%0A[Please%20add%20your%20message%20here]%0A%0ABest%20regards,"
              className="inline-block px-8 sm:px-10 md:px-12 py-2 sm:py-3 md:py-3 text-lg sm:text-xl md:text-2xl border-2 border-[#F1EFE0] text-[#F1EFE0] hover:bg-[#F1EFE0] hover:text-[#2C2721] rounded-full hover:scale-105 transition-all duration-350" 
              style={{fontFamily: 'Vixa-Regular, sans-serif'}}
            >
              Hire me
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
